import { action } from 'easy-peasy';
import * as R from 'ramda';

export default {
  mode: 'month',
  volumeMode: false,
  mip: [], // mobile invisible products

  setData: action((state, payload) => {
    const keys = Object.keys(payload);
    keys.forEach((key) => (state[key] = payload[key]));
  }),

  reset: action((state) => {
    state.mip = [];
  }),

  toggleMip: action((state, payload) => {
    state.mip = state.mip.includes(payload)
      ? R.without([payload], state.mip)
      : R.append(payload, state.mip);
  }),

  toggleMipAll: action((state, ids) => {
    state.mip = state.mip.length > 0 ? [] : ids;
  }),
};
